// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
    'aws_app_analytics': 'enable',
    'aws_cognito_identity_pool_id': 'us-east-1:894ea6df-573e-4995-826e-e3d5cec5cdf0',
    'aws_cognito_region': 'us-east-1',
    'aws_content_delivery': 'enable',
    'aws_content_delivery_bucket': 'fichacertaadminclien-hosting-mobilehub-1537257079',
    'aws_content_delivery_bucket_region': 'us-east-1',
    'aws_content_delivery_cloudfront': 'enable',
    'aws_content_delivery_cloudfront_domain': 'd1n073c24xqkwk.cloudfront.net',
    'aws_mobile_analytics_app_id': '951cebf8eafb4f5cb815ef2cf16dfd8e',
    'aws_mobile_analytics_app_region': 'us-east-1',
    'aws_project_id': '1527182c-605f-451d-9ad5-276eca8a61d4',
    'aws_project_name': 'fichacerta-admin-cliente',
    'aws_project_region': 'us-east-1',
    'aws_resource_name_prefix': 'fichacertaadminclien-mobilehub-1537257079',
}

export default awsmobile;
